/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var pli = require("../forms");

if (typeof pli.forms.registry.busyIndicator !== "object") {
    throw new Error("Form busyIndicator has not been registered in Pli.forms.registry (did you call CreateBusyIndicatorForm?)");
}

module.exports = require("./BusyIndicator");




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms-busyindicator/index.js
// module id = 499
// module chunks = 49